import React from 'react'
import { Dialog, DialogContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  root: {
    padding: '0px !important',
    backgroundColor: theme.palette.primary.popupBackground
  },
  paper: {
    margin: '25px',
    maxWidth: '450px'
  }
}))

function PopUp(props) {
  const classes = useStyles()
  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      disableBackdropClick={props.disableBackdropClick}
      classes={{ paper: `${classes.paper} ${props.className}` }}
    >
      <DialogContent classes={{ root: classes.root }}>
        {props.content}
      </DialogContent>
    </Dialog>
  )
}

PopUp.defaultProps = {
  open: false,
  handleClose: () => { },
  title: '',
  content: <></>,
  disableBackdropClick: false
}

export default PopUp